import React, { Component } from "react";

import Links from "./Links";

export class Documents extends Component {
  render() {
    const { geral, docentes, alunos } = this.props.links;
    return (
      <section className="content">
        <div className="tipoAlvo">
          <i className="fas fa-info-circle"></i>
          <h2>Geral</h2>
          <Links links={geral} />
        </div>
        <div className="tipoAlvo">
          <i className="fas fa-info-circle"></i>
          <h2>Docentes</h2>
          <Links links={docentes} />
        </div>
        <div className="tipoAlvo">
          <i className="fas fa-info-circle"></i>
          <h2>Alunos</h2>
          <Links links={alunos} />
        </div>
      </section>
    );
  }
}

export default Documents;
